import { Link } from 'react-router-dom';
import { elfCharacters } from '@/mocks/elf-characters';

export default function ElfCharactersSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            六大精灵族
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            好色精灵探访记中的每一族精灵都守护着独特的色彩力量，
            他们是色彩世界中最闪耀的存在。点击了解每一位精灵的传奇故事。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {elfCharacters.map((elf) => (
            <Link
              key={elf.id}
              to={`/article/${elf.articleSlug}`}
              className="group bg-background-50 rounded-lg overflow-hidden hover:bg-background-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={elf.imageUrl}
                  alt={`好色精灵探访记 - ${elf.name}`}
                  title={`好色精灵探访记 ${elf.name} - ${elf.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${elf.colorClass}`}></div>
                <div className="absolute bottom-3 left-4 right-4">
                  <span className="inline-block px-3 py-1 rounded-full bg-white/20 backdrop-blur-sm text-white text-xs font-medium">
                    {elf.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-1">
                  {elf.name}
                </h3>
                <p className="text-xs text-foreground-500 mb-2">{elf.title}</p>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {elf.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}